import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FeaturedEventsComponent } from './featured-events.component';
 
import { TranslateModule } from '@ngx-translate/core';
import { FeaturedEventsRoutingModule } from './featured-events-routing.module';
import { EmptyPageModule } from '../empty-page/empty-page.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule.forChild(),
        FeaturedEventsRoutingModule,
        EmptyPageModule,
    ],
    declarations: [
        FeaturedEventsComponent
    ]
})
export class FeaturedEventsModule { }
